import { ThemeProps } from "@radix-ui/themes";

// Samsung Racing — dark board theme. Starter palette only; the on-screen look
// is still TBD, so the concrete colors live in styles/themes/samsungRacing.scss
// (scoped to `.theme-samsung.samsungracing`).
export const samsung: ThemeProps = {
  appearance: "dark",
  accentColor: "indigo",
  grayColor: "slate",
  panelBackground: "translucent",
  scaling: "100%",
  radius: "small",
  className: "theme-samsung",
};
